"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["classes", "title", "buttons", "contentText", "closeText", "onClose"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {}
  };
};
var Acknowledge = /*#__PURE__*/function (_Component) {
  function Acknowledge() {
    (0, _classCallCheck2["default"])(this, Acknowledge);
    return _callSuper(this, Acknowledge, arguments);
  }
  (0, _inherits2["default"])(Acknowledge, _Component);
  return (0, _createClass2["default"])(Acknowledge, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        buttons = _this$props.buttons,
        contentText = _this$props.contentText,
        closeText = _this$props.closeText,
        onClose = _this$props.onClose,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var handleClose = function handleClose(_ref, reason) {
        (0, _objectDestructuringEmpty2["default"])(_ref);
        if (reason !== "backdropClick") {
          _this.props.onClose;
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        onClose: handleClose,
        "aria-labelledby": "simple-dialog-title"
      }, other), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, contentText), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onClose();
        }
      }, closeText)));
    }
  }]);
}(_react.Component);
Acknowledge.propTypes = {
  onClose: _propTypes["default"].func,
  contentText: _propTypes["default"].string.isRequired,
  closeText: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(Acknowledge);